var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"back",on:{"click":function($event){return _vm.back()}}},[_c('el-icon',{staticClass:"el-icon-back"}),_c('span',[_vm._v("返回")])],1),_c('span',{staticClass:"line"}),_vm._t("default",function(){return [_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }